import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["productLine", "skuId", "additionalUnitSkuId", "purchaseMotion", "screen", "trackingSource", "use", "sourceId"];
import CodeSplitEnvWrapper from 'pricing-pages-ui/components/common/env/CodeSplitEnvWrapper';
import { productForSkuIdSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import { SCREENS } from '../../../v2/constants/tracking/Screens';
import { APP } from '../../../v2/constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { checkoutProductConfigurationsSelector, productVersionConfigsWithUnitsSelector } from '../../../selectors/ProductConfigsSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtilsLegacy';
import LoadingCTA from './LoadingCTA';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This component houses the logic used for rendering a CTA for the core hub product, i.e. Marketing Hub, Sales Hub, Service Hub, etc. It is often used in conjunction with useHubPurchaseMotions
 */
const HubProductCTA = _ref => {
  let {
      productLine,
      skuId,
      additionalUnitSkuId,
      purchaseMotion,
      screen = SCREENS.PRODUCTS_PLANS,
      trackingSource,
      use = 'primary',
      sourceId = trackingSource
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const apiName = useAppSelector(state => {
    return productForSkuIdSelector(state, {
      skuId
    }).apiName;
  });
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const productConfigurations = useAppSelector(state => checkoutProductConfigurationsSelector(state, {
    productConfigurations: productVersionConfigsWithUnitsSelector(state, {
      skuId,
      additionalUnitQuantity: 0,
      additionalUnitSkuId
    }),
    subtractOwnedUnitsIfBuyingNoAdditional: isAppAuth,
    subtractOwnedSeats: isAppAuth,
    includeOnboarding: false,
    includeOnboardingFallback: false
  }));
  const {
    queryParamTerm
  } = useQueryParamTerm();

  // In the case we pass in purchaseMotion by indexing purchaseMotions[0], but the purchaseMotions array is empty. TS won't complain, but it will throw an error at runtime.
  if (!purchaseMotion) return null;
  const trackingData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${apiName}`
  };
  const sharedProps = Object.assign({
    productConfigurations,
    queryParamTerm,
    trackingSource,
    // for legacy tracking
    purchaseMotion,
    use
  }, rest);
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, sharedProps, {
      apiName,
      trackingData
    }),
    publicComponentProps: Object.assign({}, sharedProps, {
      sourceId,
      dtbSource: `pricing-page|${productLineToHub[productLine]}-hub|${trackingSource}|${apiName}`
    }),
    publicComponentLoadingState: LoadingCTA,
    authedComponentLoadingState: LoadingCTA
  });
};
export default HubProductCTA;